export const formatCurrency = (
  value: number,
  currency = "USD",
  locale = "en-US"
) => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value || 0);
};

export const formatNumber = (value: number | string, locale = "en") => {
  const numeric = typeof value === "string" ? Number(value) : value;
  if (Number.isNaN(numeric as number) || numeric === undefined) return "";
  const formattedNumber = Intl.NumberFormat(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format((numeric as number) || 0);
  return formattedNumber;
};